<template>
  <div class="filial-badge">
    <font-awesome-icon class="filial-badge__icon" icon="store" />
    <div class="filial-badge__value">
      {{ name || 'Филиал не выбран' }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FilialBadge',
    props: {
      name: { type: String, default: null },
    },
  }
</script>

<style scoped lang="less">
.filial-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid #FFE3B5;
  border-left: 3px solid @color-primary;
  border-radius: 6px;
  padding: 10px 14px;
}

.filial-badge__icon { width: 20px; height: 20px; color: @color-primary; flex-shrink: 0; }

.filial-badge__value {
  font-size: 14px;
  color: #000;
  font-weight: 500;
  line-height: 1.3;
  margin-top: 2px;
}
</style>
